<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="PART I: MY IDENTITY CHOICES">
<h1 class="ct" id="d7e164419">
<a href="#/MacD_ISBN9781418573447_epub_c7_r1#Anch00119" id="Anch0009">
<b>PART I</b>
<br/> <br/> <span class="smallcaps">
<b>MY IDENTITY CHOICES</b>
</span>
</a>
</h1>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MacD_ISBN9781418573447_epub_c12_r1.vue?352218f5